import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";
import { ReviewTaskListPage } from "@client/components/doc-center/review-task-list";

const reviewListSearchSchema = z.object({
  filter: z.string().optional(),
  q: z.string().optional(),
  page: z.number().int().positive().optional(),
});

export const Route = createFileRoute("/_app/data-center/review/")({
  validateSearch: reviewListSearchSchema,
  component: ReviewTaskListPageWrapper,
});

function ReviewTaskListPageWrapper() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  const handleSearchChange = useCallback(
    (next: { filter?: string; q?: string; page?: number }) =>
      navigate({
        to: "/data-center/review",
        search: (prev) => ({
          filter: next.filter ?? prev.filter,
          q: next.q ?? prev.q,
          // 全局 search 合并后 page 是 string|number 联合（doc-center 深链同为 page），本路由只收 number
          page: next.page ?? (typeof prev.page === "number" ? prev.page : undefined),
        }),
        replace: true,
      }),
    [navigate],
  );

  return (
    <ReviewTaskListPage
      search={search}
      onSearchChange={handleSearchChange}
    />
  );
}
